import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Media,
 
} from "reactstrap";

import { connect } from "react-redux";
import {
  getMyMRListcount,
} from "../../store/MaterialRequest/actions";

import {
  getMyPIListcount,
} from "../../store/PurchaseIndent/actions";

import {
  getRFQRequestList,
} from "../../store/RequetForQuotation/actions";

import {
  getCompareQuotationList,
} from "../../store/CompareQuotation/actions";

import {
  getPurchaseOrderList,
} from "../../store/PurchaseOrder/actions";

import {
  getIGPList,
} from "../../store/ingatepass/actions";

import {
  getMainData
} from "../../store/Dashboard/actions";

import Barchart from "./barchart";
import "./Dashboard.scss";

class StarterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      reports: [
        {
          icon: "ri-stack-line",
          title: "All Material Requests",
          value: "152",
        },
        {
          icon: "ri-store-3-line",
          title: "Pending Requests",
          value: "298",
        },
        {
          icon: "ri-shopping-bag-3-line",
          title: "Approved Requests",
          value: "450",
        },
        {
          icon: "ri-stack-line",
          title: "Rejected Requests",
          value: "152",
        },
        {
          icon: "ri-store-3-line",
          title: "Pending Items",
          value: "298",
        },
        {
          icon: "ri-shopping-bag-3-line",
          title: "Item Orders ",
          value: "450",
        },
        {
          icon: "ri-stack-line",
          title: "Pending Request",
          value: "152",
        },
        {
          icon: "ri-store-3-line",
          title: "Pending Items",
          value: "298",
        },
        {
          icon: "ri-shopping-bag-3-line",
          title: "Item Orders ",
          value: "450",
        },
      ],
    };
    this.toggleTab = this.toggleTab.bind(this);
  }
  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 6) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }

  
  componentDidMount() {

    this.props.getMainData()

    this.props.getMyMRListcount({
      mrstatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
    });
    
    this.props.getMyPIListcount({
      pistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
    });
    
    this.props.getRFQRequestList({

      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
    });

    this.props.getCompareQuotationList({
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
    });

    
    this.props.getPurchaseOrderList({
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
    });

    this.props.getIGPList({
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      department: "",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom ">
                    <h5 className="card-title-18 pt-2 d-inline-block">
                      Dashboard
                    </h5>
                  </CardHeader>
                  <CardBody className="pt-2">
                    
                    <Row>
                      <Col md={8} className="p-0">
                        <Row>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    All Material Requests
                                    </p>
                                    <h4 className="mb-0"> {this.props.mrListCount?.all_count}</h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-stack-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    Pending Requests
                                    </p>
                                    <h4 className="mb-0"> {this.props.mrListCount?.pending_count}</h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-store-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    Approved Requests
                                    </p>
                                    <h4 className="mb-0">{this.props.mrListCount?.approved_count} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-shopping-bag-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    Rejected Requests
                                    </p>
                                    <h4 className="mb-0">{this.props.mrListCount?.rejected_count} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-shopping-bag-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    All Purchase Indents
                                    </p>
                                    <h4 className="mb-0"> {this.props.PIListCount?.all_count}</h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-stack-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    Pending Indents
                                    </p>
                                    <h4 className="mb-0"> {this.props.PIListCount?.pending_count}</h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-store-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    Approved Indents
                                    </p>
                                    <h4 className="mb-0">{this.props.PIListCount?.pending_count} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-shopping-bag-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    Rejected Indents
                                    </p>
                                    <h4 className="mb-0">{this.props.PIListCount?.rejected_count} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-store-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    All Request For Quotations
                                    </p>
                                    <h4 className="mb-0"> {this.props.RFQRowListCount}</h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-stack-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    All Compare Quotation
                                    </p>
                                    <h4 className="mb-0">  {this.props.CQRowListCount} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-store-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                   All Purchase Orders
                                    </p>
                                    <h4 className="mb-0"> {this.props.POListCount} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-shopping-bag-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          <Col  md={3}>
                            <Card>
                              <CardBody>
                                <Media>
                                  <Media body className="overflow-hidden">
                                    <p className="text-truncate font-size-14 mb-2">
                                    All In Gate Passes
                                    </p>
                                    <h4 className="mb-0">{this.props.IGPRowListCount} </h4>
                                  </Media>
                                  <div className="text-primary">
                                    <i
                                      className="ri-shopping-bag-3-line font-size-24"
                                    ></i>
                                  </div>
                                </Media>
                              </CardBody>
                            </Card>
                          </Col>
                          
                        </Row>
                      </Col>
                      <Col md={4}>
                        <Card className="p-0">
                          <CardBody className="p-0" style={{ height: "450px" }}>
                            <Barchart />
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  
  const {  PIListCount,  } = state.PurchaseIndent;
  const { mrRowList, mrListCount,  } = state.Materialrequest;
  const { RFQRowListCount } = state.RequestForQuotation;
  const { CQRowListCount } = state.CompareQuotation;
  const { POListCount } = state.PurchaseOrder;
  const { IGPRowListCount } = state.ingatepass;
  const { mrdeplistcount } = state.Dashboard;

  return {
    mrRowList,
    mrListCount,
    PIListCount,
    RFQRowListCount,
    CQRowListCount,
    POListCount,
    IGPRowListCount,
    mrdeplistcount
  };
};
export default connect(mapStatetoProps, {
  getMyMRListcount,
  getMyPIListcount,
  getRFQRequestList,
  getCompareQuotationList,
  getPurchaseOrderList,
  getIGPList,
  getMainData
})(StarterPage);

